<template>
    <div>
        <unauthorized-user-meeting-popup v-if="isUnauthorized" />

        <before-time-joined-meeting-popup v-else-if="isBeforeScheduleTime" :starts-at="meetingInfo.starts_at"
            @time-reached="isBeforeScheduleTime = false" />

        <JitsiMeeting v-else-if="meetingInfo" :room-id="roomId" :meeting-info="meetingInfo"
            :current-user="currentUser" :mType="meetingType" />

    </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import socketMixin from '@/mixins/socketMixin' // 👈 Import your new mixin
import JitsiMeeting from "./JitsiMeeting.vue";
import beforeTimeJoinedMeetingPopup from "./beforeTimeJoinedMeetingPopup.vue";
import unauthorizedUserMeetingPopup from "./unauthorizedUserMeetingPopup.vue";

export default {
    components: {
        JitsiMeeting,
        beforeTimeJoinedMeetingPopup,
        unauthorizedUserMeetingPopup
    },
    mixins: [socketMixin],

    props: {
        roomId: {
            type: String,
            required: true
        },
        meetingType: {
            type: String,
            required: true
        },
        userInfo: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            currentUser: null,
            meetingInfo: null,
            isUnauthorized: false,
            isBeforeScheduleTime: false,
            cancelSource: null
        }

    },

    async mounted() {
        // 2. FIX: Execute the function with parentheses to disconnect when joining
        if (typeof this.closeSocket === "function") {
            this.closeSocket();
        }
        this.cancelSource = axios.CancelToken.source();
        await this.loadMeeting();
    },

    methods: {
        async loadMeeting() {
            try {
                let meeting = null;

                if (this.meetingType === "private") {
                    const res = await this.$store.dispatch("fetchCurrentUserInfo");
                    this.currentUser = res.data.data;
                    meeting = await this.$store.dispatch("conferenceInfo", { meeting_id: this.roomId });
                } else {
                    if (!this.userInfo) {
                        this.isUnauthorized = true;
                        return;
                    }
                    this.currentUser = this.userInfo;
                    meeting = await this.$store.dispatch("conferenceInfo", this.userInfo);
                }
                if (
                    !meeting ||
                    !meeting.token
                ) {
                    this.isUnauthorized = true;
                    return;
                }

                this.meetingInfo = meeting;

                if (meeting.starts_at) {
                    const meetingTime =
                        new Date(meeting.starts_at).getTime() * 1000;
                        const fiveMinutesInMs = 5 * 60 * 1000;
                    if (Date.now() < meetingTime) {
                        this.isBeforeScheduleTime = true;
                    }
                }
            }

            catch (error) {
                console.error("Meeting Error:", error);
                this.isUnauthorized = true;
            }

        }

    },

    beforeDestroy() {
        if (this.cancelSource) {
            this.cancelSource.cancel();
        }
        if (this.meetingType === "private") {
            // Call the raw connect method explicitly here bypassing route checks.
            if (typeof this.initSocketLifecycle === "function") {
                this.initSocketLifecycle();
            }
        }
    }
}
</script>